import cloneDeep from 'lodash/cloneDeep';
const config = cloneDeep(Object.assign({}, window.Config));
export default config;
